import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, useRoutes } from "react-router-dom";
import AuthRoute from "./components/Auth/AuthRoute";
import routes from "./config/routes";

// import reportWebVitals from './reportWebVitals';

import './index.css';

const RouterView = () => useRoutes(routes);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // <React.StrictMode>
        <Router>
            <AuthRoute>
                <RouterView />
            </AuthRoute>
        </Router>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
